<template>
  <div class="new-main-page">
    <h1 class="new-main-header">
      <img :src="theme.current.headerImage" alt="AI Logo" class="logo" />
    </h1>
    <div v-if="isViewingMentee" class="mentee-view">
      <a href="#" @click.prevent="backToList" class="back-link"
        ><span class="back-arrow">&lt;</span> Back</a
      >
      <div v-if="hasSummaryHistories" class="mentee-history scrollable-box">
        <div>
          <div v-if="selectedMenteeSummaries.length">
            <div class="summary-dates">
              <div
                v-for="(summary, index) in selectedMenteeSummaries"
                :key="summary.id"
              >
                <a
                  href="#"
                  @click.prevent="toggleSummary(index)"
                  :class="{ 'selected-summary': isSummaryVisible(index) }"
                >
                  <img
                    v-if="isSummaryVisible(index)"
                    class="fas fa-file file-icon"
                    alt="File Icon"
                  />
                  <!-- {{ formatDate(summary.sessionDate) }} -->
                  {{ summary.sessionDate }}
                </a>
              </div>
            </div>
            <p class="past-coaching-heading">Past Coaching Session Summary</p>
            <div class="summary-details">
              <div
                v-for="(summary, index) in selectedMenteeSummaries"
                :key="summary.id"
              >
                <div v-if="isSummaryVisible(index)">
                  <ul class="no-bullets">
                    <li
                      v-for="item in parseSummary(summary.summary)"
                      :key="item"
                      v-html="item"
                    ></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <p v-else>No session summaries available.</p>
        </div>
      </div>

      <div v-if="shouldShowFormContainer" class="mentee-history form-container">
        <!-- Past suggestions section -->
        <div
          v-if="
            selectedSession &&
            selectedSession.suggestions &&
            selectedSession.suggestions.length > 0
          "
          class="past-suggestions"
        >
          <h3 class="suggestions-heading">Previous Suggestions:</h3>
          <div
            v-for="(suggestion, index) in selectedSession.suggestions"
            :key="index"
            class="past-suggestion-item"
          >
            <p class="suggestion-mentor">From: {{ suggestion.mentorName }}</p>
            <textarea
              :value="suggestion.suggestion"
              class="textarea-box past-suggestion-textarea"
              rows="4"
              disabled
            ></textarea>
          </div>
        </div>
        <div
          v-else-if="selectedSession"
          class="past-suggestions no-suggestions"
        >
          <div class="textarea-box past-suggestion-textarea empty-suggestion">
            <p>No suggestions</p>
          </div>
        </div>

        <!-- New suggestion form -->
        <form @submit.prevent="submitSuggestion">
          <div class="form-header">
            <p class="form-text">Provide Suggested Session Topic Below:</p>
            <button type="submit" class="submit-button">Send</button>
          </div>
          <div class="mentee-view-container">
            <textarea
              v-model="suggestion"
              placeholder="Text that will be sent to all selected mentees chatbot as a suggested coaching topic."
              class="textarea-box"
              rows="10"
            ></textarea>
          </div>
        </form>
      </div>

      <!-- div v-if="shouldShowFormContainer" class="form-container">
                
                <form @submit.prevent="submitSuggestion" >
                    <div class="form-header">
                        <p class="form-text">Provide Suggested Session Topic Below:</p>
                        <button type="submit" class="submit-button">Send</button>
                    </div>
                    <div class="mentee-view-container">
                        <textarea v-model="suggestion" placeholder="Text  that will be sent to all selected mentees chatbot as a suggested coaching topic." class="textarea-box" rows="10"></textarea>
                    </div>
                    
                </form>
            </div -->
    </div>
    <div v-else class="mentee-select">
      <div class="filter-container">
        <input
          type="text"
          v-model="filterInput"
          placeholder="Filter..."
          class="search-input"
        />
      </div>
      <div class="table-container">
        <table class="data-table">
          <thead class="theader">
            <tr>
              <th>Name</th>
              <th>Start</th>
              <!-- th>Stage</th -->
              <th>End</th>
              <th>View</th>
              <!-- th>Delete</th -->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="mentee in filteredMentees"
              :key="mentee.id"
              :class="{ highlight: mentee.id % 2 === 0 }"
            >
              <td>{{ mentee.name }}</td>
              <td>{{ mentee.start }}</td>
              <!-- td>{{ mentee.stage }}</td -->
              <td>{{ mentee.end }}</td>
              <td>
                <button
                  class="view-button action-button"
                  @click="viewMentee(mentee)"
                >
                  View
                </button>
              </td>
              <!-- td>
                            <button class="delete-button action-button" @click="confirmDeleteMentee(mentee.id)">Delete</button>
                            </td -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from "vue";
import { useSessionStore } from "@/stores/session";
import { useThemeStore } from "@/stores/theme";
import mentorApi from "@/services/mentor_api"; // Adjust the path as needed
import swal from "@/services/swal";

export default {
  name: "MenteesPage",
  setup() {
    const session = useSessionStore();
    const filterInput = ref("");
    const selectedMentee = ref(null);
    const isViewingMentee = ref(false);
    const hasSummaryHistories = ref(false);
    const visibleSummaries = ref([]);
    const visibleSummaryIndex = ref(null);
    const viewPastSessionSuggestions = ref(true);

    const suggestion = ref("");
    const selectedSession = ref(null);

    const theme = useThemeStore();

    const filteredMentees = computed(() => {
      if (!filterInput.value) return session.mentees;
      return session.mentees.filter((mentee) =>
        Object.values(mentee).some((val) =>
          String(val).toLowerCase().includes(filterInput.value.toLowerCase()),
        ),
      );
    });

    const viewMentee = (mentee) => {
      selectedMentee.value = mentee;
      isViewingMentee.value = true;
      visibleSummaries.value = [];
      visibleSummaryIndex.value = null;
    };

    const getSummariesByUserId = (userId) => {
      // Choose the data source based on the viewPastSessionSuggestions flag
      let summaries;

      if (viewPastSessionSuggestions.value) {
        // Use data with suggestions
        summaries =
          session.pastSessionsWithSummariesAndSuggestions?.filter(
            (chat) => chat.userId === userId,
          ) || [];
      } else {
        // Use data without suggestions
        summaries =
          session.pastSessionsWithSummaries?.filter(
            (chat) => chat.userId === userId,
          ) || [];
      }

      // Map the results to a consistent format
      const formattedSummaries = summaries.map((chat) => ({
        id: chat.id,
        sessionDate: chat.sessionDate,
        summary: chat.summary,
        // Only include suggestions if viewPastSessionSuggestions is true
        suggestions: viewPastSessionSuggestions.value
          ? chat.suggestions || []
          : [],
      }));

      if (formattedSummaries.length > 0) {
        hasSummaryHistories.value = true;
        console.log(
          `Summaries with ${
            viewPastSessionSuggestions.value ? "" : "out"
          } suggestions:`,
          formattedSummaries[0].id,
        );
      }

      return formattedSummaries;
    };

    /*
        const selectedMenteeSummaries = computed(() => {
            if (!selectedMentee.value) return []
            return getSummariesByUserId(selectedMentee.value.id)
        })
        */

    // Modify the selectedMenteeSummaries computed property to trigger the watcher
    const selectedMenteeSummaries = computed(() => {
      if (!selectedMentee.value) return [];
      return getSummariesByUserId(selectedMentee.value.id);
    });

    // Add this watcher to auto-select the first summary
    watch(
      selectedMenteeSummaries,
      (newSummaries) => {
        if (
          newSummaries &&
          newSummaries.length > 0 &&
          visibleSummaryIndex.value === null
        ) {
          // Select the first summary
          toggleSummary(0);
          console.log(
            "Auto-selected first summary:",
            newSummaries[0].sessionDate,
          );
        }
      },
      { immediate: true },
    );

    const backToList = () => {
      isViewingMentee.value = false;
      selectedMentee.value = null;
    };

    const deleteMentee = (id) => {
      session.mentees = session.mentees.value.filter(
        (mentee) => mentee.id !== id,
      );
    };

    const confirmDeleteMentee = async (userId) => {
      const { isConfirmed } = await swal.fire({
        icon: "warning",
        text: "Are you sure you want to delete this mentee?",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
      });
      if (isConfirmed) {
        deleteMentee(userId);
      }
    };
    const toggleSummary = (index) => {
      visibleSummaryIndex.value =
        visibleSummaryIndex.value === index ? null : index;
      selectedSession.value = selectedMenteeSummaries.value[index];
      console.log("Selected session with suggestions:", selectedSession.value);
      shouldShowFormContainer.value = evaluateShouldShowFormContainer();
    };

    const isSummaryVisible = (index) => {
      return visibleSummaryIndex.value === index;
    };

    const formatDate = (dateStr) => {
      const firstDateStr = dateStr.split("-")[0].trim();
      const [day, month, year] = firstDateStr.split(".");
      const date = new Date(`20${year}-${month}-${day}`);
      return new Intl.DateTimeFormat("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      }).format(date);
    };

    const headerText = computed(() => {
      return isViewingMentee.value && selectedMentee.value
        ? `${session.chatbotName} Peer Mentors - Peer Mentees - ${selectedMentee.value.name}`
        : `${session.chatbotName} Peer Mentors - Peer Mentees`;
    });

    const parseSummary = (summary) => {
      return summary
        .split("\n")
        .map((item) => {
          const match = item.match(/-\s*([^:]+:)/);
          if (match) {
            const boldText = match[0];
            const restText = item.replace(boldText, "").trim();
            return `<strong>${boldText}</strong> ${restText}`;
          }
          return item;
        })
        .filter((item) => item);
    };

    const submitSuggestion = async () => {
      // userId, sessionId, suggestion
      try {
        const response = await mentorApi.sendSuggestion(
          selectedMentee.value.id,
          selectedSession.value.id,
          suggestion.value,
        );
        console.log("Suggestion submitted successfully:", response.data);
        // Optionally, clear the suggestion after submission
        suggestion.value = "";
      } catch (error) {
        console.error("Error submitting suggestion:", error);
      }
    };

    const evaluateShouldShowFormContainer = () => {
      /*
            const dateRange = selectedSession.value.sessionDate.split('-').map(dateStr => dateStr.trim())
            const [endYear, endMonth, endDay] = dateRange[1].split('.')
            const endDate = new Date(`20${endYear}-${endMonth}-${endDay}`)
            const oneWeekAgo = new Date()
            oneWeekAgo.setDate(oneWeekAgo.getDate() - 7)
            return endDate >= oneWeekAgo
            */
      return true;
    };

    // const shouldShowFormContainer = ref(evaluateShouldShowFormContainer())
    const shouldShowFormContainer = ref(false);

    onMounted(async () => {
      await session.fetchMentees();
      if (viewPastSessionSuggestions.value) {
        await session.fetchPastSessionsWithSummariesAndSuggestions();
        hasSummaryHistories.value =
          session.pastSessionsWithSummariesAndSuggestions.length > 0;
      } else {
        await session.fetchPastSessionsWithSummaries();
        hasSummaryHistories.value =
          session.pastSessionsWithSummaries.length > 0;
      }
      // await session.fetchPastSessionsWithSummaries();
      // hasSummaryHistories.value = session.pastSessionsWithSummaries.length > 0;
      //await session.fetchPastSessionsWithSummariesAndSuggestions();
      // hasSummaryHistories.value = session.pastSessionsWithSummariesAndSuggestions.length > 0;
      console.log("Fetched mentees:", session.mentees);
      console.log("Fetched past sessions:", session.pastSessionsWithSummaries);
    });

    return {
      theme,
      filterInput,
      filteredMentees,
      viewMentee,
      backToList,
      deleteMentee,
      isViewingMentee,
      selectedMentee,
      hasSummaryHistories,
      selectedMenteeSummaries,
      toggleSummary,
      isSummaryVisible,
      formatDate,
      parseSummary,
      headerText,
      submitSuggestion,
      suggestion,
      selectedSession,
      shouldShowFormContainer,
      confirmDeleteMentee,
    };
  },
};
</script>

<style scoped>
.past-coaching-heading {
  font-size: 1.2em;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 10px;
}
.past-suggestions {
  width: 100%;
  margin-bottom: 15px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 15px;
}

.suggestions-heading {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 10px;
  color: #1f6dca;
}

.past-suggestion-item {
  margin-bottom: 10px;
}

.suggestion-mentor {
  font-size: 0.9em;
  font-weight: bold;
  margin-bottom: 3px;
}

.past-suggestion-textarea {
  background-color: #f5f5f5;
  resize: none;
  color: #444;
  border: 1px solid #ddd;
  font-style: italic;
  height: auto;
  max-height: 150px;
  margin-bottom: 6px;
}
.empty-suggestion {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  color: #777;
  font-style: italic;
  height: 80px;
  border: 1px solid #ddd;
  min-height: 80px;
  padding: 10px;
}

.table-container {
  margin-top: 20px;
  margin: 0 auto;
  max-width: 70%;
  max-height: 400px;
  height: 400px;
  overflow-y: auto;
}
.search-input {
  padding: 8px;
  font-size: 16px;
  width: 50%;
  box-sizing: border-box;
  background-color: #f0f0f0;
  border-radius: 10px;
  border: 1px solid #ccc;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  overflow-y: auto;
}

.data-table td {
  padding: 2px;
  text-align: center;
  border: none;
  font-weight: normal;
}

.data-table th {
  text-align: center;
  border: none;
  font-weight: boldest;
}

.filter-container {
  display: flex;
  justify-content: center;
  width: 50%;
  margin-bottom: 10px;
  margin-top: 15px;
  max-width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

tr:hover {
  background-color: #f1f1f1;
}

input[type="text"] {
  margin-bottom: 10px;
  padding: 8px;
  width: 80%;
  box-sizing: border-box;
}

.highlight {
  /* background-color: #d3eaff;*/ /* Light blue background color */
}

.delete-button {
  background-color: #ca1f67;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.delete-button:hover {
  background-color: #a81b55; /* Darker blue on hover */
}

.view-button {
  background-color: #1f6dca; /* Dark blue color */
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.view-button:hover {
  background-color: #162a6d; /* Darker blue on hover */
}

.mentee-select {
  border-radius: 10px;
  height: 100%;
  max-width: 83%;
  box-sizing: border-box;
}

.mentee-view {
  margin-right: 5px;
}

.scrollable-box {
  max-height: 600px; /* Adjust as needed */
  max-width: 65%; /* Adjust as needed */
  overflow-y: scroll;
  overflow-x: hidden;
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  word-wrap: break-word;
}

.mentee-history {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-left: 17.5%;
  background: #ffffffb2;
  overflow-x: auto;
  overflow-y: auto;
}

.summary-dates {
  display: flex;
  flex-direction: column;
}

.summary-dates a {
  cursor: pointer;
  color: black;
  font-weight: 500; /* Slightly bolder */
  text-decoration: none; /* Remove underline */
  margin-bottom: 6px;
}

.summary-dates a:hover {
  color: darkblue;
}

.summary-dates .selected-summary {
  font-weight: bolder;
  color: darkblue;
}

.summary-details {
  margin-top: 15px;
}

.summary-details p {
  margin-bottom: 10px;
}
.no-bullets {
  list-style-type: none;
  padding-left: 0;
}

.file-icon {
  width: 13px;
  height: 13px;
  margin-right: 3px;
}
.back-link-old {
  align-self: flex-start;
  margin-left: 17.5%; /* Match the margin-left of the containers */
}
.back-link {
  display: block;
  margin-top: 10px;
  margin-left: 17.5%; /* Match the margin-left of the containers */
  color: blue;
  text-decoration: none; /* Remove underline */
  cursor: pointer;
}

.back-link:hover {
  color: darkblue;
}

.back-arrow {
  font-weight: bold;
  margin-right: 5px;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 65%;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  max-width: 65%;
  justify-content: center;
  margin: 10px auto 0; /* Add top margin to match the mentee-history */
  margin-left: 17.5%; /* Match the margin-left of mentee-history */
}
.form-container p {
  margin: 0; /* Adjust margins */
  font-size: 1.5em;
}
.form-container-old p {
  margin-bottom: 0;
  margin-top: 50px;
  font-size: 1.5em;
}

.form-text {
  font-family: Inria Sans;
  font-size: 28px;
  font-weight: 700;
  line-height: 33.57px;
  text-align: center;
}
form {
  margin-top: 0; /* Remove default margin */
  margin-bottom: 0;
}
.textarea-box {
  width: 100%;
  max-height: 400px;
  max-width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: #ffffffb2;
  box-sizing: border-box;
}

.textarea-box::placeholder {
  font-weight: bold; /* Make the placeholder text bolder */
}

.submit-button {
  background-color: #1f6dca; /* Dark blue color */
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.submit-button:hover {
  background-color: #162a6d; /* Darker blue on hover */
}

.mentee-view-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 10px;
}

.new-main-page {
  display: flex;
  flex-direction: column;
  height: var(--app-height);
  min-height: 100vh; /* Ensure the main page takes at least the full viewport height */
  min-height: -webkit-fill-available;
  width: 85%; /* Ensure the main page takes the full width */
  margin: 0;
  padding: 0;
  overflow: auto;
}

.new-main-page h1,
.new-main-page p,
.new-main-page form,
.new-main-page div {
  width: 100%;
  text-align: left;
}

.new-main-header {
  display: flex;
  justify-content: left;
  align-items: center;
  height: 150px; /* Adjust as needed */
  padding: 0;
  margin: 0;
}

@media (max-width: 768px) {
  .suggestions-heading {
    font-size: 1em;
  }

  .suggestion-mentor {
    font-size: 0.8em;
  }

  .past-suggestion-textarea {
    font-size: 0.85em;
    max-height: 100px;
  }
  .form-container {
    width: 100%;
    max-width: 100%;
  }
  .form-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .form-text {
    font-size: 18px;
    line-height: normal;
  }
  .data-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    border: none;
  }

  .data-table th,
  .data-table td {
    padding: 2px;
    font-size: 10px;
  }

  .action-button {
    padding: 3px 6px;
    font-size: 10px;
  }

  .mentee-view-old {
    width: 100%;
    max-height: 70vh; /* Increase the height on mobile devices */
    overflow-y: auto; /* Enable vertical scrolling */
    overflow-x: hidden; /* Hide horizontal overflow */
    padding: 10px;
  }
  .mentee-view {
    margin-right: 5px;
    background: #e9e5d6;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Align items to the left */
  }

  .mentee-history {
    width: 100%;
    max-height: 70vh; /* Increase the height on mobile devices */
    font-size: 12px; /* Make the text smaller on mobile devices */
    overflow-x: hidden; /* Enable horizontal scrolling if needed */
    margin-top: 20px;
    margin-left: 0%;
  }

  .scrollable-box {
    max-height: 70vh; /* Increase the height on mobile devices */
    max-width: 100%; /* Adjust as needed */
    padding: 10px;
    font-size: 10px; /* Make the text smaller on mobile devices */
  }
  .new-main-page {
    display: flex;
    flex-direction: column;
    height: var(--app-height);
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }
  .new-main-header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5%;
    padding: 5;
    margin: 5;
    margin-top: 20px;
  }
  .new-main-page h1,
  .new-main-page p,
  .new-main-page form,
  .new-main-page div {
    width: 100vw;
    text-align: left;
  }
  .header {
    height: auto;
  }
  .logo {
    width: 100%;
    height: auto;
  }
}
</style>
